export default "__VITE_ASSET__BjE_N3dX__"